import { ChangeEvent, FC } from "react";

import { ErrorText } from "../ErrorText";

export interface IInputProps {
  label?: string;
  placeholder: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  isRequired?: boolean;
  isDisabled?: boolean;
  error?: string;
  isError?: boolean
}

export const Input: FC<IInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  onFocus,
  isRequired,
  isDisabled,
  error,
  isError
}) => {
  return (
    <div className="home-page-input">
      <label className="home-page-input__label">
        {label}
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </label>
      <input
        className={`home-page-input__input ${ isError ? "error" : "" }`}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onFocus={onFocus}
        disabled={isDisabled}
      />
      {error && <ErrorText title={error} />}
    </div>
  );
};
